import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TWellAnalyseSerializedInternalState,
  WellAnalyseWidgetEntity,
} from 'src/pages/dashboard/features/well-analyse-widget/WellAnalyseWidget.entity';

export function serializeWellAnalyseWidget(widget: WellAnalyseWidgetEntity): TSerializedWidget {
  const internalState: TWellAnalyseSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      xAxisIndex: widget.stateParams.xAxisIndex,
      operationCode: widget.stateParams.operationCode,
      legendVisible: widget.stateParams.legendVisible,
      timeZone: widget.stateParams.timeZone,
      wellboreId: widget.stateParams.wellboreId,
      datazoomX: widget.stateParams.datazoomX,
      datazoomY: widget.stateParams.datazoomY,
      filter: widget.stateParams.filter,
      viewType: widget.stateParams.viewType,
      typeOfHole: widget.stateParams.typeOfHole,
      directionOfMovement: widget.stateParams.directionOfMovement,
      showAverage: widget.stateParams.showAverage,
      showMedian: widget.stateParams.showMedian,
      averageMedianColor: widget.stateParams.averageMedianColor,
      showStartMarkers: widget.stateParams.showStartMarkers,
      orientationOfGroup: widget.stateParams.orientationOfGroup,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
